import React from "react"
import styled from "styled-components"

const SectionTitleElement = styled.h2`
  font-family: "La Luxes Script";
  text-align: center;
  width: 100%;
  font-size: 60px;
  @media (${({ theme }): string => theme.screenSizes.sm}) {
    font-size: 100px;
  }
`

type Props = {
  children: React.ReactNode
}

const SectionTitle: React.FC<Props> = ({ children, ...props }: Props) => {
  return <SectionTitleElement {...props}>{children}</SectionTitleElement>
}

export default SectionTitle
